const Header = ({ data }) => {
    console.log(data.textType)

    if (data.textType === 'title') return <h5 className="pb-2">{data.text}</h5>
    if (data.textType === 'sub-title') return <h6 className="pb-2">{data.text}</h6>
    return <p></p>

}

export default Header